import Div from '@jumbo/shared/Div';
import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';
import FullScreenLoader from 'app/components/ListingPageLoader';
import { getKcFabricCodeList } from 'app/services/apis/ListApi/kcFabricCodeList';
import { getInventoryReportTakaNoList, getTakaNoList } from 'app/services/apis/ListApi/takaNoList';
import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    kc_fabric_code: Yup.string().required('Fabric code is required'),
    taka_no: Yup.string().required('Taka number is required'),
});

const InventoryReport = () => {
    const [kcFabricCodeList, setKcFabricCodeList] = useState([]);
    const [takaNoList, setTakaNoList] = useState([]);

    const handleSubmit = async function (values) {
        try {
            const config = {
              withCredentials: true,
              headers: {
                withCredentials: true,
              },
            };
      
            const response = await axios.post(
              `${process.env.REACT_APP_URL}/api/inventory-report/fetch-report/${values?.kc_fabric_code}/${values?.taka_no}`,
              config
            );
      
      
            if (response?.status === 200) {
              Swal.fire({
                title: "Success",
                text: response?.data?.message || "Inventory Report Fetch Successfully",
                icon: "success",
                showConfirmButton: true,
              });
              window.open(response?.data?.downloadLink);
            }
          } catch (error) {
            Swal.fire({
              title: "Failed",
              text: error?.response?.data?.message || 'Something went wrong',
              icon: "error",
              showConfirmButton: true,
            });
          }
    }

    const formik = useFormik({
        initialValues: {
            kc_fabric_code: "",
            taka_no: ""
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit
    });

    const fetchkcFabricCodeList = async function () {
        try {
            const list = await getKcFabricCodeList();
            setKcFabricCodeList(list);
        } catch (error) {
            Swal.fire({
                title: error?.message || error?.response?.data?.message,
                icon: "error",
                showConfirmButton: true,
            });
        }
    }
    const fetchTakaNoList = async function (kc_fabric_code) {
        try {
            if (!kc_fabric_code) {
                setTakaNoList([]);
                return;
            }
            const list = await getInventoryReportTakaNoList(kc_fabric_code);
            setTakaNoList(list);
        } catch (error) {
            Swal.fire({
                title: error?.message || error?.response?.data?.message,
                icon: "error",
                showConfirmButton: true,
            });
        }
    }

    useEffect(() => {
        fetchkcFabricCodeList();
    }, []);

    return (
        <Box sx={{ width: '100%', mt: -4 }}>
            {formik.isSubmitting && <FullScreenLoader />}
            <Typography variant='h2'>Inventory Report</Typography>
            <Grid container my={3} gap={3}>
                <Grid item lg={3} md={4} xs={12}>
                    <Autocomplete
                        freeSolo
                        key={formik.values.kc_fabric_code}
                        size="small"
                        id="kc_fabric_code"
                        name="KC Fabric Code"
                        options={kcFabricCodeList || []}
                        value={formik.values.kc_fabric_code || null}
                        getOptionLabel={(option) => {
                            if (option instanceof Object && !Array.isArray(option)) {
                                return option.kc_fabric_code;
                            } else {
                                return option;
                            }
                        }}
                        onBlur={() => formik.setFieldTouched("kc_fabric_code", true)}
                        onChange={(e, newValue) => {
                            formik.setFieldValue("kc_fabric_code", newValue?.kc_fabric_code);
                            fetchTakaNoList(newValue?.kc_fabric_code);
                        }}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                {...props}
                            >
                                {option.kc_fabric_code}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="KC Fabric Code"
                                error={formik.touched.kc_fabric_code && Boolean(formik.errors.kc_fabric_code)}
                                helperText={formik.touched.kc_fabric_code && formik.errors.kc_fabric_code}
                                sx={{
                                    width: "100%",
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item lg={3} md={4} xs={12}>
                    <Autocomplete
                        key={formik.values.taka_no}
                        size="small"
                        id="taka_no"
                        name="Taka No"
                        options={takaNoList || []}
                        value={formik.values.taka_no || null}
                        getOptionLabel={(option) => {
                            if (option instanceof Object && !Array.isArray(option)) {
                                return option.taka_no?.toString();
                            } else {
                                return option?.toString();
                            }
                        }}
                        onBlur={() => formik.setFieldTouched("taka_no", true)}
                        onChange={(e, newValue) => {
                            formik.setFieldValue("taka_no", newValue?.taka_no);
                        }}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                {...props}
                            >
                                {option.taka_no}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Taka No"
                                error={formik.touched.taka_no && Boolean(formik.errors.taka_no)}
                                helperText={formik.touched.taka_no && formik.errors.taka_no}
                                sx={{
                                    width: "100%",
                                }}
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <Div>
                <Button
                    variant="contained"
                    size="small"
                    sx={{ marginRight: 1 }}
                    onClick={formik.handleSubmit}
                >
                    Apply
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                        formik.resetForm()
                    }}
                >
                    Clear
                </Button>
            </Div>
        </Box>
    )
}

export default InventoryReport